/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StaffSurveyOverviewDetail = {
    properties: {
        overview: {
    type: 'StaffSurveyOverview',
},
        questions: {
    type: 'array',
    contains: {
        type: 'StaffSurveyQuestionWithOptions',
    },
},
        submissions: {
    type: 'array',
    contains: {
        type: 'StaffSurveySubmissionWithResponses',
    },
},
    },
};